import React from 'react';

import './Asterisk.scss';

function Asterisk() {
  return <span className='text-error body1 asterisk'>*</span>;
}

export default Asterisk;
